export default {
  get_all: { method: "get", url: "api/users" },
  show: { method: "get", url: "api/users{/id}" },
  store: { method: "post", url: "api/users" },
  update: { method: "put", url: "api/users{/id}" },
  delete: { method: "delete", url: "api/users{/id}" },

  profileStore: { method: "post", url: "api/profile" }
};
